import { all, call, put, takeLatest } from "redux-saga/effects";
import ratesApi from "api/rates";
import * as act from "store/actions/rates";

function* getRatesSaga({ query, cb }) {
  try {
    const data = yield call(ratesApi.getRates, query);

    yield put(act.setRates(data));
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

export function* ratesSaga() {
  yield all([takeLatest(act.VM_GET_RATES, getRatesSaga)]);
}
